import React, { useState, useEffect } from "react";
import LoaderComponent from "../../../components/Spinner/LoaderComponent";
import BootstrapTable from "react-bootstrap-table-next";
import axiosInstance from "../../../utils/axiosInstance";
import { useDateTime } from "../../../components/Helper/DateTime";
import ButtonTransparent from "../../../components/Buttons/ButtonTransparent";
import AddIcon from "../../../assets/images/add-icon.png";
import AddOrEdit from "./AddOrEdit";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import Toast from "../../../components/Toast/Toast";
import { DateTimeFormat } from "../../../utils/formatDateTime";
import Pagination from "../../../components/pagination/pagination";

const Schedules = () => {
  const { setRefresh, dateTime } = useDateTime();
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [id, setId] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [reconSchedules, setReconSchedules] = useState([]);
  const [reportingSchedules, setReportingSchedules] = useState([]);
  const [systemSchedules, setSystemSchedules] = useState([]);

  const [reconPagination, setReconPagination] = useState({
    page: 1,
    totalElements: 0,
    pageSize: 15,
    totalPages: 0,
  });

  const [reportingPagination, setReportingPagination] = useState({
    page: 1,
    totalElements: 0,
    pageSize: 15,
    totalPages: 0,
  });

  const [systemPagination, setSystemPagination] = useState({
    page: 1,
    totalElements: 0,
    pageSize: 15,
    totalPages: 0,
  });
  const fetchReconSchedules = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get(
        `/scheduler?page=${reconPagination.page - 1}&size=${
          reconPagination.pageSize
        }&scheduler_group_code=recon-schedule`
      );
      setReconSchedules(res.data.schedulers);
      setReconPagination({
        page: res?.page?.number + 1 || 1,
        totalElements: res?.page?.totalElements || 0,
        pageSize: res?.page?.size || 15,
        totalPages: res?.page?.totalPages || 0,
      });
    } catch (error) {
      console.error("Error fetching recon schedules", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchReportingSchedules = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get(
        `/scheduler?page=${reportingPagination.page - 1}&size=${
          reportingPagination.pageSize
        }&scheduler_group_code=reporting-schedule`
      );
      setReportingSchedules(res.data.schedulers);
      setReportingPagination({
        page: res?.page?.number + 1 || 1,
        totalElements: res?.page?.totalElements || 0,
        pageSize: res?.page?.size || 15,
        totalPages: res?.page?.totalPages || 0,
      });
    } catch (error) {
      console.error("Error fetching reporting schedules", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchSystemSchedules = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get(
        `/scheduler?page=${systemPagination.page - 1}&size=${
          systemPagination.pageSize
        }&scheduler_group_code=system-schedule`
      );
      setSystemSchedules(res.data.schedulers);
      setSystemPagination({
        page: res?.page?.number + 1 || 1,
        totalElements: res?.page?.totalElements || 0,
        pageSize: res?.page?.size || 15,
        totalPages: res?.page?.totalPages || 0,
      });
    } catch (error) {
      console.error("Error fetching system schedules", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReconSchedules();
    fetchReportingSchedules();
    fetchSystemSchedules();
  }, []);
  useEffect(() => {
    fetchReconSchedules();
    setRefresh(() => () => {
      fetchReconSchedules();
    });
    return () => {
      setRefresh(() => () => {});
    };
  }, [reconPagination.page, reconPagination.pageSize]);

  useEffect(() => {
    fetchReportingSchedules();
    setRefresh(() => () => {
      fetchReportingSchedules();
    });
    return () => {
      setRefresh(() => () => {});
    };
  }, [reportingPagination.page, reportingPagination.pageSize]);

  useEffect(() => {
    fetchSystemSchedules();
    setRefresh(() => () => {
      fetchSystemSchedules();
    });
    return () => {
      setRefresh(() => () => {});
    };
  }, [systemPagination.page, systemPagination.pageSize]);

  const HandleDeleteScheduler = () => {
    axiosInstance
      .delete(`/scheduler/${id}`)
      .then((res) => {
        // eslint-disable-next-line
        if (res.message.status == 200) {
          fetchReconSchedules();
          fetchReportingSchedules();
          fetchSystemSchedules();
          setIsDeleteModal(false);
          Toast("Record deleted!", "success");
        } else {
          setIsDeleteModal(false);
          Toast(res.message.description, "error");
        }
      })
      .catch((err) => {
        console.log(err);
        setIsDeleteModal(false);
      });
  };

  const schedulerType = (value, label) => {
    if (label === "triggerTypeId" && value?.toString() === "1") {
      return "Cron Expression";
    } else if (label === "triggerTypeId" && value?.toString() === "2") {
      return "Fixed Interval";
    } else if (label === "schedulerTypeId" && value?.toString() === "1") {
      return "Kafka";
    } else if (label === "schedulerTypeId" && value?.toString() === "2") {
      return "API";
    } else {
      return "-";
    }
  };

  const columns = (hideActionColumn) => {
    return [
      { hidden: true, dataField: "id", text: "ID" },
      {
        dataField: "schedulerName",
        text: "Schedule Name",
        formatter: (cell) => cell ?? "-",
        sort: true,
        style: { cursor: "default" },
      },
      {
        dataField: "code",
        text: "Code",
        formatter: (cell) => cell ?? "-",
        sort: true,
        style: { cursor: "default" },
      },
      {
        dataField: "groupCode",
        text: "Group",
        formatter: (cell) => cell ?? "-",
        // sort: true,
        style: { cursor: "default" },
      },
      {
        dataField: "schedulerTypeId",
        text: " Scheduler Type",
        formatter: (cell) =>
          cell ? schedulerType(cell, "schedulerTypeId") : "-",
        sort: true,
        style: { cursor: "default" },
      },
      {
        dataField: "triggerTypeId",
        text: "Trigger Type",
        formatter: (cell) =>
          cell ? schedulerType(cell, "triggerTypeId") : "-",
        sort: true,
        style: { cursor: "default" },
      },
      {
        dataField: "triggerValue",
        text: "Trigger Value",
        formatter: (cell) => cell ?? "-",
        sort: true,
        style: { cursor: "default" },
      },
      {
        dataField: "autoStart",
        text: "Auto Start",
        formatter: (cell) => cell ?? "-",
        sort: true,
        style: { cursor: "default" },
      },
      {
        dataField: "activeInd",
        text: "Active",
        formatter: (cell) => (cell === true ? "Active" : "Inactive" ?? "-"),
        sort: true,
        style: { cursor: "default" },
      },
      {
        dataField: "lastStartDatetime",
        text: "Last Start Time",
        formatter: (cell) => DateTimeFormat(dateTime, cell) ?? "-",
        sort: true,
        style: { cursor: "default" },
      },
      {
        dataField: "nextStartDatetime",
        text: "Next Start Time",
        formatter: (cell) => DateTimeFormat(dateTime, cell) ?? "-",
        sort: true,
        style: { cursor: "default" },
      },

      hideActionColumn === true && {
        dataField: "action",
        text: "Action",
        formatter: (cell, row) => {
          return (
            <div className="d-flex justify-content-around">
              {/* <ShowForPermission permission="clk_workflow_edit"> */}
              <i
                className="fa fa-pencil text-info"
                aria-hidden="true"
                onClick={() => {
                  setId(row.id);
                  setIsEdit(true);
                  setShowModal(true);
                }}
                style={{ fontSize: "16px", cursor: "pointer" }}
              />
              {/* </ShowForPermission> */}
              {/* <ShowForPermission permission="clk_workflow_del"> */}
              <i
                className="fa fa-trash text-danger"
                aria-hidden="true"
                onClick={() => {
                  setIsDeleteModal(true);
                  setId(row.id);
                }}
                style={{ fontSize: "16px", cursor: "pointer" }}
              />
              {/* </ShowForPermission> */}
            </div>
          );
        },
      },
    ];
  };
  return (
    <>
      {loading && (
        <div
          className="spinner-center"
          style={{ top: "0%", left: "0%", zIndex: 2000 }}
        >
          <LoaderComponent />
        </div>
      )}
      <div style={{ opacity: !loading ? "1" : "0.07" }}>
        <div className="row page-header d-flex justify-content-between">
          <div className="col-sm-12 col-lg-12 page-header d-flex justify-content-between m-0">
            <div className="title">Recon Schedules</div>
            <div>
              <ButtonTransparent
                onClick={() => {
                  setIsEdit(false);
                  setShowModal(true);
                }}
                title={"Add Scheduler"}
                icon={AddIcon}
              />
              {showModal && (
                <AddOrEdit
                  showModal={showModal}
                  setShowModal={setShowModal}
                  isEdit={isEdit}
                  setIsEdit={setIsEdit}
                  getData={() => {
                    fetchReconSchedules();
                    fetchReportingSchedules();
                    fetchSystemSchedules();
                  }}
                  id={id}
                  setId={setId}
                  data={(reconSchedules || []).concat(
                    reportingSchedules || [],
                    systemSchedules || []
                  )}
                />
              )}
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12">
            <BootstrapTable
              bordered={true}
              bootstrap4={true}
              classes="rs-table table-layout-auto table-custom-style"
              wrapperClasses="overflow-y-auto fancy-scroll"
              keyField="id"
              data={reconSchedules || []}
              columns={columns(true)}
              noDataIndication="No data found!"
            />
          </div>
          <div className="col-12 mb-3">
            <Pagination
              setPage={(val) =>
                setReconPagination((prev) => ({ ...prev, page: val }))
              }
              page={reconPagination?.page || 1}
              pageSize={reconPagination.pageSize || 15}
              setPageSize={(val) =>
                setReconPagination((prev) => ({ ...prev, pageSize: val }))
              }
              totalPages={reconPagination?.totalPages || 0}
              totalElements={reconPagination?.totalElements || 0}
              data={reconSchedules?.reconSchedules || []}
            />
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-12">
            <div className="title mb-3">Reporting Schedules</div>
            <BootstrapTable
              bordered={false}
              bootstrap4={true}
              classes="rs-table table-layout-auto table-custom-style"
              wrapperClasses="overflow-y-auto fancy-scroll"
              keyField="id"
              data={reportingSchedules || []}
              columns={columns(true)}
              noDataIndication="No data found!"
            />
          </div>
          <div className="col-12 mb-3">
            <Pagination
              setPage={(val) =>
                setReportingPagination((prev) => ({
                  ...prev,
                  page: val,
                }))
              }
              page={reportingPagination?.page || 1}
              pageSize={reportingPagination?.pageSize || 15}
              setPageSize={(val) =>
                setReportingPagination((prev) => ({
                  ...prev,
                  pageSize: val,
                }))
              }
              totalPages={reportingPagination?.totalPages || 0}
              totalElements={reportingPagination?.totalElements || 0}
              data={reportingSchedules || []}
            />
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12">
            <div className="title mb-3">System Schedules</div>
            <BootstrapTable
              bordered={false}
              bootstrap4={true}
              classes="rs-table table-layout-auto table-custom-style"
              wrapperClasses="overflow-y-auto fancy-scroll"
              keyField="id"
              data={systemSchedules || []}
              columns={columns(false)}
              noDataIndication="No data found!"
            />
          </div>
          <div className="col-12 mb-3">
            <Pagination
              setPage={(val) =>
                setSystemPagination((prev) => ({
                  ...prev,
                  page: val,
                }))
              }
              page={systemPagination?.page || 1}
              pageSize={systemPagination?.pageSize || 15}
              setPageSize={(val) =>
                setSystemPagination((prev) => ({
                  ...prev,
                  pageSize: val,
                }))
              }
              totalPages={systemPagination?.totalPages || 0}
              totalElements={systemPagination?.totalElements || 0}
              data={systemSchedules || []}
            />
          </div>
        </div>
        <ConfirmationModal
          isShow={isDeleteModal}
          title={"Delete Scheduler"}
          message={"Are you sure you want to delete this scheduler?"}
          hideModal={() => {
            setIsDeleteModal(false);
          }}
          confirmAction={() => HandleDeleteScheduler()}
        />
      </div>
    </>
  );
};

export default Schedules;
